if (!customElements.get('product-card-image-slider')) {
    customElements.whenDefined('carousel-slider').then(() => {
        class ProductCardImageSlider extends CarouselSlider {
            constructor() {
                super();
                this.productCard = this.closest('product-card');
                this.productCardSwatches = this.productCard.querySelectorAll('.card__swatches .opt-btn');
                this.slides = this.querySelectorAll('.slider__item');

                  this.isDragging = false;
                  this.startX = 0;
                  this.scrollLeft = 0;
                  this.slideSpan = this.slides[0]?.offsetWidth || 0; // Ensure slide width is captured
          
              
                this.productCard.addEventListener('change', this.handleSwatchChange.bind(this));
            }

            init() {
                super.init();

                 if (this.slides.length > 1 && window.innerWidth < 900) {
                       this.slider.addEventListener("mousedown", this.handleMouseDown.bind(this));
                        this.slider.addEventListener("mousemove", this.handleMouseMove.bind(this));
                        this.slider.addEventListener("mouseup", this.handleMouseUp.bind(this));
                        this.slider.addEventListener("mouseleave", this.handleMouseUp.bind(this));
                
                        this.slider.addEventListener("touchstart", this.handleMouseDown.bind(this), { passive: true });
                        this.slider.addEventListener("touchmove", this.handleMouseMove.bind(this), { passive: true });
                        this.slider.addEventListener("touchend", this.handleMouseUp.bind(this));
  
                      window.addEventListener("resize", () => {
                          this.slideSpan = this.slides[0]?.offsetWidth || 0;
                      });
                 } else {
                      this.productCard.addEventListener('mouseover', this.handleHover.bind(this));
                      this.productCard.addEventListener('mouseout', this.handleHoverOut.bind(this));
                 }

                // Set up the loop behavior on the next and prev buttons
                this.nextBtn.addEventListener('click', this.handleNextButtonClick.bind(this));
                this.prevBtn.addEventListener('click', this.handlePrevButtonClick.bind(this));


                // If swatches are enabled, mark the swatch anchors in the slideshow
                if (this.productCardSwatches) {
                    const activeSlide = this.querySelector('.slider__item[aria-current]');
                    const activeSwatchId = this.productCard.querySelector('.card__swatches .opt-btn:checked')?.dataset.mediaId || activeSlide?.dataset.mediaId;
                    let activeSwatchSlide;

                    if (activeSwatchId) {
                        this.productCardSwatches.forEach((swatch) => {
                            const swatchSlide = this.querySelector(`[data-media-id="${swatch.dataset.mediaId}"]`);
                            if (swatchSlide) {
                                swatchSlide.setAttribute('data-swatch-anchor', 'true');

                                // Set the active set of slideshow images
                                if (swatchSlide.dataset.mediaId === activeSwatchId) {
                                    activeSlide.removeAttribute('aria-current');
                                    swatchSlide.setAttribute('aria-current', 'true');
                                    activeSwatchSlide = swatchSlide;
                                }
                            }
                        });
                    }

                    if (activeSwatchSlide) this.handleSwatchChange(null, activeSwatchSlide.dataset.mediaId);
                } else {
                    // Show the current slider item
                    const activeSlide = this.querySelector('.slider__item[aria-current]');
                    if (activeSlide) {
                        this.handleSwatchChange(null, activeSlide.dataset.mediaId);
                    } else {
                        this.slider.slides[1]?.setAttribute('aria-current', 'true');
                    }
                }
            }






          

            handleMouseDown(event) {
                this.isDragging = true;
                this.startX = event.pageX || event.touches[0].pageX; // ✅ FIXED
                this.currentTranslate = this.slider.scrollLeft;
                event.preventDefault(); // Prevents text selection
            }
        
            handleMouseMove(event) {
                if (!this.isDragging) return;
                const x = event.pageX || event.touches[0].pageX;
                const moveDistance = this.startX - x; // Negative if swiping right, positive if left
                this.slider.scrollLeft = this.currentTranslate + moveDistance;
            }
        
            handleMouseUp(event) {
                if (!this.isDragging) return;
                this.isDragging = false;
        
                // Determine swipe direction
                const endX = event.pageX || (event.changedTouches ? event.changedTouches[0].pageX : 0);
                const swipeDistance = this.startX - endX;
              
                if (swipeDistance > 50) {
                    this.moveNext(); // Swiped left
                } else if (swipeDistance < -50) {
                    this.movePrev(); // Swiped right
                } else {
                    this.snapToSlide(); // Small movement → Snap back
                }
            }
        
            moveNext() {
                const currentIndex = Math.round(this.slider.scrollLeft / this.slideSpan);
                if (currentIndex < this.slides.length - 1) {
                    this.slider.scrollTo({ left: this.slides[currentIndex + 1].offsetLeft, behavior: "smooth" });
                } else {
                    this.slider.scrollTo({ left: 0, behavior: "smooth" });
                }
            }
        
            movePrev() {
                const currentIndex = Math.round(this.slider.scrollLeft / this.slideSpan);
                if (currentIndex > 0) {
                    this.slider.scrollTo({ left: this.slides[currentIndex - 1].offsetLeft, behavior: "smooth" });
                } else {
                    this.slider.scrollTo({ left: this.slides[this.slides.length - 1].offsetLeft, behavior: "smooth" });
                }
            }
        
            snapToSlide() {
                const currentIndex = Math.round(this.slider.scrollLeft / this.slideSpan);
                this.slider.scrollTo({ left: this.slides[currentIndex].offsetLeft, behavior: "smooth" });
            }

           







          
            /**
             * Updates the visibility of slides based on the state of card swatches.
             * @param {string} mediaId - The media ID to match against the slides.
             */
            updateSlideVisibility(mediaId) {
                let hideSlide = true;
                let foundMediaId = false;
                this.slides.forEach((slide) => {
                    if (!foundMediaId && slide.getAttribute('data-media-id') === mediaId) {
                        hideSlide = false;
                        foundMediaId = true;
                    } else if (foundMediaId && slide.hasAttribute('data-swatch-anchor')) {
                        hideSlide = true;
                    }

                    slide.toggleAttribute('hidden', hideSlide);
                });

                this.setButtonStates();
            }

            /**
             * Handles 'change' events in the product card swatches.
             * @param {object} evt - Event object.
             * @param {string} mediaId - The media ID to match against the slides.
             */
            handleSwatchChange(evt, mediaId) {
                const swatchMediaId = evt?.target.dataset.mediaId || mediaId;
                if (swatchMediaId) {
                    this.updateSlideVisibility(swatchMediaId);

                    const variantMedia = this.querySelector(`[data-media-id="${swatchMediaId}"]`);
                    if (variantMedia) {
                        const left = variantMedia.closest('.slider__item').offsetLeft;
                        this.slider.scrollTo({ left, behavior: 'smooth' });
                    }
                }
            }

            /**
             * Sets the disabled state of the nav buttons.
             */
            setButtonStates() {
                if (!this.prevBtn && !this.nextBtn) {
                    return;
                }
            }

            /**
             * Handles 'scroll' events on the slider element.
             */
            scrollInProgress() {
                this.slider.querySelector('[aria-current]')?.removeAttribute('aria-current');
            }

            /**
             * Handles 'scroll' events on the slider element.
             */
            handleScroll() {
                super.handleScroll();
                this.slides[this.currentIndex].setAttribute('aria-current', 'true');
            }

            /**
               * Custom handler for next button click 
               */
            handleNextButtonClick() {
                if (!this.slideSpan) {
                    this.slideSpan = this.slides?.[0]?.offsetWidth || 0;
                    if (!this.slideSpan) {
                        console.error("Slide span (width) could not be determined.");
                        return;
                    }
                }

                const currentIndex = Math.round(this.slider.scrollLeft / this.slideSpan);
              
                if (currentIndex === this.slides.length - 1) {
                    const secondSlide = this.slides[1];

                    this.slides.forEach(slide => slide.removeAttribute('aria-current'));
                    this.slides[0].setAttribute('aria-current', 'true');

                    this.slider.scrollTo({ left: this.slides[0].offsetLeft, behavior: 'smooth' });
                    // Safely remove aria-current from the to-first slide 
                    setTimeout(() => {
                        if (secondSlide) {
                            secondSlide.removeAttribute('aria-current');
                            // Scroll instantly to the last slide
                            this.slider.scrollTo({ left: this.slides[0].offsetLeft, behavior: 'smooth' });
                        }
                    }, 0);
                } else {
                    this.slides.forEach(slide => slide.removeAttribute('aria-current'));
                    this.slides[currentIndex + 1].setAttribute('aria-current', 'true');

                    // Use requestAnimationFrame to force scrolling
                    requestAnimationFrame(() => {
                        this.slider.scrollTo({ left: this.slides[currentIndex + 1].offsetLeft, behavior: 'smooth' });
                    });
                }
            }

            /**
             * Custom handler for prev button click 
             */
            handlePrevButtonClick() {
                if (!this.slideSpan) {
                    this.slideSpan = this.slides?.[0]?.offsetWidth || 0;
                    if (!this.slideSpan) {
                        console.error("Slide span (width) could not be determined.");
                        return;
                    }
                }

                const currentIndex = Math.round(this.slider.scrollLeft / this.slideSpan);

                if (currentIndex === 0) {
                    const secondLastSlide = this.slides[this.slides.length - 2];
                    // Remove aria-current from all slides unless the flag is set
                    this.slides.forEach(slide => slide.removeAttribute('aria-current'));
                    this.slides[this.slides.length - 1].setAttribute('aria-current', 'true');

                    this.slider.scrollTo({ left: this.slides[this.slides.length - 1].offsetLeft, behavior: 'smooth' });
                    // Safely remove aria-current from the second-to-last slide 
                    setTimeout(() => {
                        if (secondLastSlide) {
                            secondLastSlide.removeAttribute('aria-current');
                            // Scroll instantly to the last slide
                            this.slider.scrollTo({ left: this.slides[this.slides.length - 1].offsetLeft, behavior: 'smooth' });
                        }
                    }, 0);
                } else {
                    this.slides.forEach(slide => slide.removeAttribute('aria-current'));
                    this.slides[currentIndex - 1].setAttribute('aria-current', 'true');

                    // Use requestAnimationFrame to force scrolling
                    requestAnimationFrame(() => {
                        this.slider.scrollTo({ left: this.slides[currentIndex - 1].offsetLeft, behavior: 'smooth' });
                    });
                }
            }

            /**
             * Custom handler for hover
             */
            handleHover() {
                if (this.slides.length > 1) {
                    const nextSlide = this.slides[1];
                    if (nextSlide) {
                        const left = nextSlide.offsetLeft;
                        this.slider.scrollTo({ left, behavior: 'instant' });
                        this.currentSlideIndex = 1;
                    }
                }
            }

            handleHoverOut() {
                if (this.slides.length > 0) {
                    const firstSlide = this.slides[0];
                    if (firstSlide) {
                        const left = firstSlide.offsetLeft;
                        this.slider.scrollTo({ left, behavior: 'instant' });
                        this.currentSlideIndex = 0;
                    }
                }
            }

        }
        customElements.define('product-card-image-slider', ProductCardImageSlider);
    });
}